import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import { ro } from "date-fns/locale";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./AddOrdersAndAdditionalPappers.css";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import axiosInstance from "../../../Config/axiosInstance";

// Înregistrăm localizarea pentru react-datepicker
registerLocale("ro", ro);

const AddOrdersAndAdditionalPappers = () => {
  const navigate = useNavigate();
  
  // State pentru DatePicker
  const [orderDate, setOrderDate] = useState(null);
  
  const [formData, setFormData] = useState({
    orders_or_additional: 1,
    pmpc_contract_number: "",
    order_additional_number: "",
    order_additional_description: "",
    supplier: "",
    alert_days: "3",
    order_additional_date: "",
    status: "",
  });

  const [suppliers, setSuppliers] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const animatedComponents = makeAnimated();
  const [contracts, setContracts] = useState([]);
  const [formErrors, setFormErrors] = useState({});

  // Funcție pentru gestionarea datelor din DatePicker
  const handleDateChange = (date) => {
    // Convertim data în format YYYY-MM-DD pentru backend
    const isoDate = date ? date.toISOString().split("T")[0] : "";
    
    setFormData(prev => ({
      ...prev,
      order_additional_date: isoDate
    }));

    // Actualizăm state-ul pentru DatePicker
    setOrderDate(date);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSupplierChange = (selectedOption) => {
    setFormData({ ...formData, supplier: selectedOption ? selectedOption.value : "" });
  };

  const handleRadioChange = (event) => {
    setFormData({
      ...formData,
      orders_or_additional: event.target.value === "order" ? 1 : 0, // 1 pentru 'order' si 0 pentru 'additional'
    });
  };

  //validare si trimitere formular
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormErrors({}); // Resetează erorile anterioare

    try {
      await axiosInstance.post("/orders-additional-pappers/", formData);
      navigate(-1); // Success
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setFormErrors(error.response.data);
      } else {
        console.error("Error adding orders:", error);
      }
    }
  };

  //Preluare furnizori
  useEffect(() => {
    axiosInstance
      .get("/suppliers/")
      .then((response) => {
        const supplierOptions = response.data.map((supplier) => ({
          value: supplier.id,
          label: supplier.name,
        }));
        setSuppliers(supplierOptions);
      })
      .catch((error) => console.error("Error fetching suppliers:", error));
  }, []);

  //Preluare statusuri
  useEffect(() => {
    axiosInstance
      .get("/status-orders-additional/")
      .then((response) => {
        const options = response.data.status_choices.map(([value, label]) => ({
          value,
          label
        }));
        setStatusOptions(options);
      })
      .catch((error) => console.error("Error fetching status choices:", error));
  }, []);

  //Preluare contracte
  useEffect(() => {
    axiosInstance
      .get("/supplier-contracts/")
      .then((response) => {
        const contractOptions = response.data.map((contract) => ({
          value: contract.id,
          label: `${contract.contract_number} - ${suppliers.find(s => s.value === contract.supplier)?.label || 'Unknown Supplier'}`,
        }));
        setContracts(contractOptions);
      })
      .catch((error) => console.error("Error fetching supplier contracts:", error));
  }, [suppliers]);

  //Filtrarea furnizorilor dupa contract
  const filteredSuppliers = formData.pmpc_contract_number
    ? suppliers.filter((supplier) =>
      contracts.some(
        (contract) =>
          contract.value === formData.pmpc_contract_number &&
          contract.label.includes(supplier.label)
      )
    )
    : suppliers;

  return (
    <div className="add-orders-additional-pappers-page">
      <div className="add-container">
        <div className="header">
          <ArrowBackIcon className="back-arrow" onClick={() => navigate(-1)} />
          <h2 className="add-title">Add Orders And Additional Papers</h2>
        </div>

      </div>
      <hr className="title-separator" />
      <div className="add-container">
        <form onSubmit={handleSubmit} className="add-form">
          <div className="form-group">
            <RadioGroup
              value={formData.orders_or_additional === 1 ? "order" : "additional"}
              onChange={handleRadioChange}
              row
            >
              <FormControlLabel
                value="order"
                control={<Radio />}
                label="Order"
                sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px" } }}
              />
              <FormControlLabel
                value="additional"
                control={<Radio />}
                label="Additional paper"
                sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px" } }}
              />

            </RadioGroup>
          </div>


          <div className="form-group">
            <label htmlFor="order_additional_number" className="label">
              Order / Additional paper number <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              id="order_additional_number"
              type="text"
              name="order_additional_number"
              value={formData.order_additional_number}
              onChange={handleChange}
              className="input"
              required
            />
            {formErrors.order_additional_number && (
              <div className="error-message">
                This number already exists.
              </div>
            )}

          </div>


          <div className="form-group">
            <label htmlFor="pmpc_contract_number" className="label">
              PMPC contract number {formData.orders_or_additional === 0 && <span style={{ color: 'red' }}>*</span>}
            </label>
            <Select
              id="pmpc_contract_number"
              name="pmpc_contract_number"
              classNamePrefix="react-select"
              options={contracts}
              value={contracts.find((c) => c.value === formData.pmpc_contract_number) || null}
              onChange={(selectedOption) => setFormData({ ...formData, pmpc_contract_number: selectedOption ? selectedOption.value : "" })}
              components={animatedComponents}
              isClearable
              styles={{
                control: (provided) => ({
                  ...provided,
                  borderRadius: "8px",
                }),
              }}
              required={formData.orders_or_additional === 0}  // Devine obligatoriu doar când este 'Additional paper'
            />
          </div>

          <div className="form-group">
            <label htmlFor="order_additional_description" className="label">Order / Additional paper description <span style={{ color: 'red' }}>*</span></label>
            <textarea
              id="order_additional_description"
              name="order_additional_description"
              value={formData.order_additional_description}
              onChange={handleChange}
              className="textarea"
              required
            />
          </div>

          <div className="form-group-row">
            <div className="form-group">
              <label htmlFor="supplier" className="label">Supplier <span style={{ color: 'red' }}>*</span></label>
              <Select
                id="supplier"
                name="supplier"
                classNamePrefix="react-select"
                options={filteredSuppliers}
                value={filteredSuppliers.find((s) => s.value === formData.supplier) || null}
                onChange={handleSupplierChange}
                components={animatedComponents}
                isClearable
                styles={{
                  control: (provided) => ({
                    ...provided,
                    borderRadius: "8px",
                  }),
                }}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="order_additional_date" className="label">Order Date <span style={{ color: 'red' }}>*</span></label>
              <div className="datepicker-container addsuppliers-datepicker">
                <DatePicker
                  selected={orderDate}
                  onChange={handleDateChange}
                  dateFormat="dd.MM.yyyy"
                  locale="ro"
                  placeholderText="dd.mm.yyyy"
                  className="datepicker-input"
                  required
                  wrapperClassName="datepicker-wrapper"
                />
                <span className="calendar-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <line x1="8" y1="2" x2="8" y2="6" />
                    <line x1="3" y1="10" x2="21" y2="10" />
                  </svg>
                </span>
              </div>
            </div>
          </div>

          <div className="form-group-row">
            <div className="form-group">
              <label htmlFor="alert_days" className="label">Alert Days</label>
              <input
                id="alert_days"
                type="number"
                name="alert_days"
                value={formData.alert_days}
                onChange={handleChange}
                className="input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="status" className="label">Status <span style={{ color: 'red' }}>*</span></label>
              <Select
                id="status"
                name="status"
                classNamePrefix="react-select"
                options={statusOptions}
                required
                value={statusOptions.find((s) => s.value === formData.status) || null}
                onChange={(selectedOption) => setFormData({ ...formData, status: selectedOption.value })}
                components={animatedComponents}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    borderRadius: "8px",
                    minHeight: "34px",
                  }),
                }}
              />
            </div>
          </div>

          <div className="form-group-row">
            <div className="button-group-inline">
              <button type="button" className="button discard" onClick={() => navigate(-1)}>
                Discard
              </button>
              <button type="submit" className="button save">Save</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddOrdersAndAdditionalPappers;